<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

import { useKidStore } from '../model/store'
import KidDisciplineBalance from './KidDisciplineBalance.vue'

defineOptions({
  name: 'KidBalanceInfo',
})

const kidStore = useKidStore()
</script>

<template>
  <div class="kid-balance-info">
    <AppText name="body1-medium">
      Lesson balance
    </AppText>
    <div class="kid-balance-info__list">
      <KidDisciplineBalance
        v-for="discipline in kidStore.getDisciplines"
        :key="discipline.id"
        :discipline="discipline"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./KidBalanceInfo.scss" />
